<script>
import RepositorySearch from "../../abstract/RepositorySearch.js";

export default RepositorySearch.extend({
  props: {
    defaultEmail: {
      type: String
    }
  },
  data() {
    return {
      options: {
        model: null,
        title: ""
      },
      sortColumn: "created_at",
      sortColumnDirection: "desc",
      endpoint: "/api/reports",
      limit: 20,
      modal: {
        active: false,
        visible: [],
        hiddenDefault: ["Псевдоним"],
        email: this.defaultEmail,
        report: {
          fields: [],
          data: [],
          url: null
        }
      },
      hiddenLoading: false
    };
  },
  methods: {
    clear() {
      this.options.title = "";
    },
    openReport(report) {
      if (!_.isObject(report)) {
        let id = report;
        report = { id };
      }
      axios
        .get(this.endpoint + report.id)
        .then(response => {
          _.merge(this.modal.report, response.data);
          let { content } = response.data;
          content = content || "";

          switch (response.data.content_type) {
            case "text/csv": {
              let data = [];
              _.each(content.split("\n"), (row, index) => {
                let cols = row.split(",");
                if (index == 0) {
                  this.modal.report.fields = cols;
                  this.modal.visible = _.difference(
                    cols,
                    this.modal.hiddenDefault
                  );
                } else {
                  data.push(cols);
                }
              });
              this.modal.report.data = data;
              break;
            }
            default: {
              this.modal.report.data = response.data.description;
              break;
            }
          }

          this.$nextTick(() => {
            this.modal.active = true;
          });
        })
        .catch(error => {
          this.toast("error", "@unexpected", error);
        });
    },
    getReportFields(report) {
      let fields = [];
      _.each(report.fields, (field, index) => {
        if (_.indexOf(this.modal.visible, field) > -1) {
          fields.push(index);
        }
      });
      return fields;
    },
    send(report) {
      let loading = this.$loading.open();
      let fields = this.getReportFields(report);

      axios
        .post(`/api/reports/${report.id}/send`, {
          email: this.modal.email,
          fields: fields.join(",")
        })
        .then(response => {
          this.toast("success", "Отчет был отправлен на указанный адрес");
          this.modal.active = false;
        })
        .catch(error => {
          switch (_.get(error.response, "status")) {
            case 422: {
              this.toast(
                "warning",
                _.get(error.response, "data.errors.email.0", "Неверный формат")
              );
              break;
            }
            default: {
              this.toast("error", "@unexpected", error);
            }
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    download(report) {
      let fields = this.getReportFields(report);
      window.open(
        `/reports/${report.id}/download?fields=` + fields.join(","),
        "_blank"
      );
    },
    print(report) {
      let fields = this.getReportFields(report);
      window.open(report.url + "?fields=" + fields.join(","));
    },
    remove: function(report) {
      this.$dialog.confirm({
        title: "Удаление отчета",
        message: `Вы уверены, что хотите удалить данный отчет?`,
        confirmText: "Удалить отчет",
        cancelText: "Отмена",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .delete(`/api/reports/${report.id}`)
            .then(response => {
              this.toast("success", "Отчет был успешно удален");
              _.delay(() => {
                window.open("/reports", "_self");
              }, 2000);
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        }
      });
    }
  },
  watch: {
    loading(value) {
      if (value == false) {
        this.hiddenLoading = false;
      }
    }
  },
  mounted() {
    let id = this.$route.query.show;
    if (id) {
      this.hiddenLoading = true;
      this.openReport(id);
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/reports/Index.vue